/* @flow */
import { Store as FluxStore } from 'flux/utils';

import CustomStore from 'lib/Store';

declare type Store = CustomStore | FluxStore;

/**
 * Creates a mixin that links state with the given stores
 * @param  {Array} stores list of store singletons to link to
 * @return {React Mixin} mixin that amends component mount methods to link store states
 */
// typecheck: ignore statement
export default function linkStateWithStores(stores: Store[]) {
  return {
    updateStateFromStores() {
      const f = () => {
        if (this.isMounted()) {
          this.setState(this.getStateFromStores());
        }
      };
      if (typeof this.needsAnimationFrame === 'function' && this.needsAnimationFrame()) {
        window.requestAnimationFrame(f);
      } else {
        f();
      }
    },

    componentDidMount() {
      this.__emitterSubscriptions = stores.map(s =>
        s.addListener(this.updateStateFromStores));
    },

    componentWillUnmount() {
      this.__emitterSubscriptions.forEach(subscription => subscription.remove());
      this.__emitterSubscriptions = [];
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/mixins/linkStateWithStores.js